// stores/useDeleteConfirmationModalStore.js
import { create } from "zustand";

export const useDeleteConfirmationModalStore = create((set) => ({
  isDeleteModalOpen: false,
  deleteMessage: "",
  isDeleteModalLoading: false,
  confirmButtonText: "Submit",
  onDeleteConfirm: async () => {},

  openDeleteModal: ({ buttonText, message, onConfirm }) =>
    set({
      confirmButtonText: buttonText,
      isDeleteModalOpen: true,
      deleteMessage: message,
      isDeleteModalLoading: false,
      onDeleteConfirm: onConfirm,
    }),

  setDeleteModalLoading: (loading) => set({ isDeleteModalLoading: loading }),

  closeDeleteModal: () =>
    set({
      isDeleteModalOpen: false,
      deleteMessage: "",
      confirmButtonText: "Submit",
      isDeleteModalLoading: false,
      onDeleteConfirm: () => {},
    }),
}));
